export default function (x, decimals, zeroReplace) {
  // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (x) {
    if (parseFloat(x) == 0 && zeroReplace) {
      return '-'
    } else {
      return Number(parseFloat(x).toFixed(decimals)).toLocaleString('en', {
        minimumFractionDigits: decimals
      });
    }
  } else {
    return zeroReplace ? '-' : 0
  }
}
